import classNames from 'classnames';

import styles from './Vignette.module.css';

type VignetteProps = {
    type: 'radial' | 'bottomLeft' | 'none';
};

const Vignette = ({ type }: VignetteProps) => {
    return (
        <span
            className={classNames(styles.Root, {
                [styles.radial]: type === 'radial',
                [styles.bottomLeft]: type === 'bottomLeft',
            })}
        />
    );
};

export default Vignette;
